import React from 'react';
import DashboardPdqComponent from './dashboard-pdq.component';

function DashboardPdq() {
    return <DashboardPdqComponent />;
}

export default DashboardPdq;
